import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { TranslateModule } from "@ngx-translate/core";
import { BadgeGeneratorModule } from "app/back-office/shared/components/badge-generator/badge-generator.module";
import { CustomDateTimePickerModule } from "app/back-office/shared/components/custom-date-time-picker/custom-date-time-picker.module";
import { SearchBarModule } from "app/back-office/shared/components/search-bar/search-bar.module";
import { DirectivesModule } from "app/back-office/shared/directives/directives.module";
import { PipesModule } from "app/back-office/shared/pipes/pipes.module";
import { SharedCommonModule } from "app/back-office/shared/common.module";
import { CastToFormArrayModule } from "app/shared/pipe/cast-to-form-array/cast-to-form-array.module";
import { LoaderModule } from "../loader/loader.module";
import { OrderCustomDatesPipe } from "./pipe/order-custom-dates.pipe";
import { NewOrderItemCustomQtyDateComponent } from "./new-order-item-custom-qty-date.component";
import { NewOrderItemAccordionListComponent } from "./views/accordion-list/new-order-item-accordion-list.component";
import { NewOrderItemGroupedByOriginalDateComponent } from "./views/grouped-by-original-date/new-order-item-grouped-by-original-date.component";
import { NewOrderItemGroupedByCustomDateComponent } from "./views/grouped-by-custom-date/new-order-item-grouped-by-custom-date.component";
import { NewOrderItemGroupedByStyleCodeComponent } from "./views/grouped-by-style-code/new-order-item-grouped-by-style-code.component";
import { ItemsTableComponent } from "./views/shared/items-table/items-table.component";

@NgModule({
    imports: [
      NgbModule,
      CommonModule,
      SharedCommonModule,
      DirectivesModule,
      LoaderModule,
      FormsModule,
      ReactiveFormsModule,
      TranslateModule.forChild(),
      BadgeGeneratorModule,
      CastToFormArrayModule,
      CustomDateTimePickerModule,
      PipesModule,
      SearchBarModule,
    ],
    declarations: [
      NewOrderItemCustomQtyDateComponent,
      OrderCustomDatesPipe,
      NewOrderItemAccordionListComponent,
      NewOrderItemGroupedByOriginalDateComponent,
      NewOrderItemGroupedByCustomDateComponent,
      NewOrderItemGroupedByStyleCodeComponent,
      ItemsTableComponent,
    ],
    exports: [
      NewOrderItemCustomQtyDateComponent
    ]
  })export class NewOrderItemCustomQtyDateModule { }